import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbAlertModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared/shared.module';
import { AlterarPropostaComponent } from './alterar-proposta/alterar-proposta.component';
import { CadastrarApoliceComponent } from './cadastrar-apolice/cadastrar-apolice.component';
import { CadastrarPropostaComponent } from './cadastrar-proposta/cadastrar-proposta.component';
import { ConsultarPropostaComponent } from './consultar-proposta/consultar-proposta.component';
import { FormularioConsultaComponent } from './consultar-proposta/formulario-consulta/formulario-consulta.component';
import { OutputTemplateConsultaComponent } from './consultar-proposta/output-template-consulta/output-template-consulta.component';
import { AlterarApoliceComponent } from './alterar-apolice/alterar-apolice.component';

@NgModule({
    declarations: [
        CadastrarPropostaComponent,
        CadastrarApoliceComponent,
        ConsultarPropostaComponent,
        FormularioConsultaComponent,
        OutputTemplateConsultaComponent,
        AlterarPropostaComponent,
        AlterarApoliceComponent,

    ],
    exports: [
        CadastrarPropostaComponent,
        CadastrarApoliceComponent,
        ConsultarPropostaComponent,
        FormularioConsultaComponent,
        OutputTemplateConsultaComponent,
        AlterarPropostaComponent,
        AlterarApoliceComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        NgbAlertModule,
    ],
})
export class RnpaPessoasModule { }
